<ion-header><app-detailheader type="dossier" (notify)="onNotifyDetailHeader($event)"></app-detailheader>
  <ion-item lines="none" class="factsheet-title" *ngIf="thematicFiles">
    <ion-label>
      <div class="factsheet-title-icon">
        <span class="pb-icon-pb-icon_pdf">
          <span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span>
        </span>
      </div>
      <div class="factsheet-h1"> {{ thematicFileName }} </div>
    </ion-label>
  </ion-item>
  <ion-item lines="none" class="separator"></ion-item>
</ion-header>
<ion-content class="ion-no-padding">
	<ion-card>
		<div class="thematicfiles-wrapper clear">
			<div class="thematicfile-container" *ngFor="let thematicFile of thematicFiles">
				<img src="{{thematicFile.image_url}}" (click)= "openPdf(thematicFile.pdf_id, thematicFile.thematic_file_newspaper_subname, thematicFile.pdf_url)"/>
					{{thematicFile.thematic_file_title}}
			</div>
		</div>
	</ion-card>
  <app-cookie-info></app-cookie-info>
  <app-one-per-week [show]="showOpenPerWeek"></app-one-per-week>
</ion-content>
<ion-footer><app-bottom-menu [isActive] = "isActivePage"></app-bottom-menu></ion-footer>
<app-pop-up [show]="tempPopUp" [data]="popup" (popUpNotify)="onNotifyPopUp($event)" #temppopup></app-pop-up>
<ion-spinner *ngIf="showSpinner" name="lines" color="primary"></ion-spinner>
